import {
  SyringeDriverRunDto,
  SyringeDriverRunScheduledActivityStatusDto,
  SyringeDriverRunStatusDto
} from "server-openapi";
import {SyringeDriverRunActivityTypeDto} from "server-openapi/dist/generated-sdk/api";

export function mergeSyringeDriverRuns(fromServer: SyringeDriverRunDto, localCopy: SyringeDriverRunDto): SyringeDriverRunDto {
  let result: SyringeDriverRunDto = {...fromServer};
  localCopy.activities ??= [];
  localCopy.activities?.forEach(activity => {
    // If the activity is not on the server, then add it from the client.
    if (!fromServer.activities?.some(x => x.clinicalSystemId == activity.clinicalSystemId)) {
      result.clientUpdatedAt = activity.clientUpdatedAt;
      result.activities!.push(activity);
      if (activity.infusion) {
        result.infusion = {...activity.infusion};
      }
      if (activity.site) {
        result.site = {...activity.site};
      }
      if (activity.scheduledEnd) {
        result.scheduledEnd = activity.scheduledEnd
      }
      if (activity.statusCheck) {
        result.statusCheck = {...activity.statusCheck};
      }
      if (activity.scheduledActivityId) {
        const scheduledActivity = result.scheduledActivities?.find(x => x.hsId === activity.scheduledActivityId);
        if (scheduledActivity) {
          scheduledActivity.status = SyringeDriverRunScheduledActivityStatusDto.Performed;
        }
      }
      if (activity.diluent) {
        result.diluent = activity.diluent;
      }
      if (activity.line) {
        result.line = {...activity.line};
      }

      // Always update the comment from the latest activity, even if it's blank, as any previous entered one may no
      // longer apply to the current state of the run when a new activity is recorded.
      result.comment = activity.comment;
      
      if (activity.activityType == SyringeDriverRunActivityTypeDto.Start || activity.activityType == SyringeDriverRunActivityTypeDto.Restart) {
        result.status = SyringeDriverRunStatusDto.Running;
      }
      else if (activity.activityType == SyringeDriverRunActivityTypeDto.Pause) {
        result.status = SyringeDriverRunStatusDto.Paused;
      }
      else if (activity.activityType == SyringeDriverRunActivityTypeDto.Stop || activity.activityType == SyringeDriverRunActivityTypeDto.Cease) {
        result.status = SyringeDriverRunStatusDto.Stopped;
      }
    }
  });
  return result;
}
